import { computed, defineComponent } from "vue";
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import MypageBadge from "~/components/MypageBadge.vue";
import { RoomSelectViewModel } from "~/pages/common/models/RoomSelectViewModel";
import { HanyoKb, RoomSb } from "~/extensions/utils/DefineTypes";
export default defineComponent({
    components: { MypageBadge },
    name: "RoomSelectCard",
    props: {
        viewModel: {
            type: RoomSelectViewModel,
            required: true
        }
    },
    setup(props) {
        const $q = useQuasar();
        const isMobile = computed(() => $q.screen.lt.md);
        const isParking = computed(() => props.viewModel.roomSb === RoomSb.Parking);
        return {
            HanyoKb,
            isParking,
            isMobile
        };
    }
});
